'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$() {
}
export { $c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ as $c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ };
$p = $c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$;
/** @constructor */
function $h_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$() {
}
export { $h_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ as $h_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ };
$h_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$.prototype = $p;
$p.vT = (function(fa) {
  return fa.gy;
});
var $d_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$, "app.data.FormQuantity$given_Extract_FormQuantity$", ({
  DJ: 1,
  a: 1,
  ia: 1
}));
export { $d_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ as $d_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ };
var $n_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$;
function $m_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$() {
  if ((!$n_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$)) {
    $n_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ = new $c_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$();
  }
  return $n_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$;
}
export { $m_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ as $m_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$ };
//# sourceMappingURL=app.data.-Form-Quantity$given_-Extract_-Form-Quantity$.js.map
